module.exports = __webpack_public_path__ + "media/images/mobile-app-2x-bd1faa03a87ab1cd1bdecd3ce29496cb.png";